import { render, staticRenderFns } from "./SolicitudCursos.vue?vue&type=template&id=72de4734&scoped=true"
import script from "./SolicitudCursos.vue?vue&type=script&lang=js"
export * from "./SolicitudCursos.vue?vue&type=script&lang=js"
import style0 from "./SolicitudCursos.vue?vue&type=style&index=0&id=72de4734&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72de4734",
  null
  
)

export default component.exports